// Piano note definitions
export const pianoNotes = [
  // Bass Clef Notes (from top to bottom) - lines 0 to 4
  { note: 'A3', freq: 220.00, midi: 57, staff: 'bass', line: 0 },
  { note: 'G3', freq: 196.00, midi: 55, staff: 'bass', line: 0.5 },
  { note: 'F3', freq: 174.61, midi: 53, staff: 'bass', line: 1 },
  { note: 'E3', freq: 164.81, midi: 52, staff: 'bass', line: 1.5 },
  { note: 'D3', freq: 146.83, midi: 50, staff: 'bass', line: 2 },
  { note: 'C3', freq: 130.81, midi: 48, staff: 'bass', line: 2.5 },
  { note: 'B2', freq: 123.47, midi: 47, staff: 'bass', line: 3 },
  { note: 'A2', freq: 110.00, midi: 45, staff: 'bass', line: 3.5 },
  { note: 'G2', freq: 98.00, midi: 43, staff: 'bass', line: 4 },
  
  // Treble Clef Notes (from top to bottom) - lines 0 to 4
  { note: 'F5', freq: 698.46, midi: 77, staff: 'treble', line: 0 },
  { note: 'E5', freq: 659.25, midi: 76, staff: 'treble', line: 0.5 },
  { note: 'D5', freq: 587.33, midi: 74, staff: 'treble', line: 1 },
  { note: 'C5', freq: 523.25, midi: 72, staff: 'treble', line: 1.5 },
  { note: 'B4', freq: 493.88, midi: 71, staff: 'treble', line: 2 },
  { note: 'A4', freq: 440.00, midi: 69, staff: 'treble', line: 2.5 },
  { note: 'G4', freq: 392.00, midi: 67, staff: 'treble', line: 3 },
  { note: 'F4', freq: 349.23, midi: 65, staff: 'treble', line: 3.5 },
  { note: 'E4', freq: 329.63, midi: 64, staff: 'treble', line: 4 },
  { note: 'D4', freq: 293.66, midi: 62, staff: 'treble', line: 4.5 }
];

// Map pitch to actual musical note on staff with exact line positions
export const mapToStaffPosition = (pitchValue) => {
  // Find the closest piano note
  let closestNote = pianoNotes[0];
  let minDiff = Math.abs(pitchValue - pianoNotes[0].freq);
  
  for (const note of pianoNotes) {
    const diff = Math.abs(pitchValue - note.freq);
    if (diff < minDiff) {
      minDiff = diff;
      closestNote = note;
    }
  }
  
  // Convert line position to exact staff position
  let noteLevel;
  if (closestNote.staff === 'bass') {
    // Bass clef: 5 lines from line 0 (bottom) to line 4 (top)
    noteLevel = 0.9 - (closestNote.line * 0.1);
  } else {
    // Treble clef: 5 lines from line 0 (bottom) to line 4 (top)
    noteLevel = 0.4 - (closestNote.line * 0.075);
  }
  
  // Clamp to reasonable bounds
  noteLevel = Math.max(0.05, Math.min(0.95, noteLevel));
  
  return { 
    staff: closestNote.staff, 
    noteLevel,
    musicalNote: closestNote.note,
    frequency: closestNote.freq,
    line: closestNote.line
  };
};